module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av443-55a6e76b32ee2ca8fee8252b933b0c3c.jpg";